module.exports = __webpack_public_path__ + "static/media/home_sold.3aa56020.svg";